<div class="collapsible-container">
  <button
    class="w-full text-left text-sm font-bold cursor-pointer flex justify-between items-center"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen()">
    <span>{{ title() }}</span>
    <span class="arrow" [class.rotated]="isOpen()">▼</span>
  </button>

  @if (isOpen()) {
    <div class="collapsible-content">
      <ng-content></ng-content>
    </div>
  }
</div>
